module.exports = __webpack_public_path__ + "img/qrcode.ec92664d.png";